import React, { useState } from "react";
import {
  Grid,
  Button,
  Typography,
  makeStyles,
  Theme,
  createStyles,
  IconButton,
} from "@material-ui/core";
import styled from "styled-components";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ExtensionButton from "../ExtensionButton";
import { ReactComponent as SearchEngineIcon } from "../../assets/imgs/onboarding/search_engine.svg";
import { ReactComponent as UserInterfaceIcon } from "../../assets/imgs/onboarding/user_interface.svg";
import { ReactComponent as ScrumIcon } from "../../assets/imgs/onboarding/scrum_board.svg";
import { ReactComponent as ReportAnalysisIcon } from "../../assets/imgs/onboarding/report_analysis.svg";
import { ReactComponent as ProfileIcon } from "../../assets/imgs/onboarding/profile_analysis.svg";
import { ReactComponent as HikingIcon } from "../../assets/imgs/onboarding/hiking.svg";

interface IOnboardingProps {
  onClose(): void;
}

const pages = [
  {
    id: 1,
    image: <UserInterfaceIcon />,
    text:
      "Welcome to faktaul - a tool that supports you collecting information online.",
  },
  {
    id: 2,
    image: <SearchEngineIcon />,
    button: <ExtensionButton />,
    text:
      "First things first: in order to collect information you need to install faktuals chrome plugin. It helps you to collect information on the internet. Click here to install it:",
  },
  {
    id: 3,
    image: <ScrumIcon />,
    text:
      "Folders allow you to structure your findings in order to find them later. Depending on your plan you can also collaborate with others on your research.",
  },
  {
    id: 4,
    image: <ReportAnalysisIcon />,
    text:
      "Your dashboard shows you the most recent articles. Premium allows you to also monitor selected sources to stay up to date.",
  },
  {
    id: 5,
    image: <ProfileIcon />,
    text:
      "In your settings you can set up your profile and give us feedback on the tool. (We would be very happy about that)",
  },
  {
    id: 6,
    image: <HikingIcon />,
    text:
      "Have fun collecting insights online. We are happy to have you on board",
  },
];
const Onboarding: React.FC<IOnboardingProps> = ({ onClose }) => {
  const [page, setPage] = useState(0);
  const classes = useStyles();

  const handlePageChange = () => {
    if (page === pages.length - 1) onClose();
    else setPage(page + 1);
  };

  return (
    <div>
      <Grid container justify="center">
        <Grid item className={classes.imgContainer}>
          {pages[page].image}
        </Grid>
        <Grid item className={classes.textContainer}>
          <Typography>{pages[page].text}</Typography>
          {!!pages[page].button && pages[page].button}
        </Grid>
        <Grid item className={classes.footerContainer}>
          <Grid container alignItems="center">
            <Grid item md={11} sm={11} className={classes.footer}>
              {pages.map((page_info) => (
                <DotPage
                  key={page_info.id}
                  isPassed={page_info.id <= page + 1}
                />
              ))}
            </Grid>
            <Grid item md={1}>
              <IconButton size="small" onClick={handlePageChange}>
                <ArrowForwardIosIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    footerContainer: {
      width: "100%",
      backgroundColor: "#E6E6E6",
    },
    imgContainer: {
      display: "flex",
      justifyContent: "center",
      padding: "20px",
      width: "100%",
      boxShadow: "2px 2px 20px rgba(0, 0, 0, 0.2)",
    },
    textContainer: {
      backgroundColor: "#E6E6E6",
      padding: "10px",
      width: "100%",
    },
    footer: {
      padding: "10px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
      backgroundColor: "#E6E6E6",
    },
  })
);

export const DotPage = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 10px;
  margin: 2px;
  background-color: ${(props) => (!props.isPassed ? "#C4C4C4" : "#00B0F0")};
`;

export default Onboarding;
